import { Box, styled } from '@mui/material';

const BackgroundImage = styled('div')({
  backgroundImage: 'url(/login-background.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  width: '100%',
  height: '100%',
});

const InnerLogo = styled('div')({
  position: 'absolute',
  backgroundImage: 'url(/login-logo.svg)',
  backgroundSize: 'fit',
  backgroundPosition: 'center center',
  width: '100%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
});

export const Logo = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        position: 'relative',
      }}
    >
      <BackgroundImage />
      <InnerLogo />
    </Box>
  );
};
